/*
  Updated by Justin Chang on August 3 2017

  Super Properties:
    userId
    loyaltyId (11 digits)

  Profile Properties
    Application ID
    Adjoy Standalone App
    Bluetooth enabled
    Browser
    OS
    Carrier
    App version (incrementing)



  Events
    1. Start Session
      Register Super Props
      App Start (increment)
      Loyalty Card Linked
      Person
      Session Interval

    2. Campaigns
      Engagements (increment)
      Campaigns (increment)
      Complete Engagement
      Complete Campaign
      Enjoyment Response - Yes/No

    3. End of Session
      Session Duration

    4. Account
      Account Screen
      Account screen - $1 Activation
      Account screen - $3 Activation
      Account screen - $6 Activation
      Account screen - $9 Activation
      Unlink Card

    5. Other
      First Time Tutorial (set once)
      Get Started button (home page)
      Privacy Policy (increment)
      FAQs           (increment)
      Terms of Use   (increment)

    TODO track ImageLoadingDuration, ImageLoadingDuration1, ImageLoadingDuration2
    TODO track VolumeWhenVideoFinished
    TODO track Unlink Card
    TODO track Click on Feed item
    TODO track Account Screen
    TODO fix session interval - problem: grabbing sess. interval from cookies even though not same loyalty card
*/
import mixpanel from '../../mixpanel';
import Cookies from 'js-cookie';
import { VERSION } from '../../config';

import {
  START_TIMER,
  // ADD_TO_TOTAL_SESSION_DURATION
} from './constants';

// Event Listeners
// import pageVisibilityListener from '../../eventListeners/pageVisibilityListener';


/*
  Register Mixpanel Super Properties
  This must be the first step in order for mixpanel to work
*/
const defaultSuperProps = {
  userId: undefined,
  loyaltyId: undefined
}
export function registerSuperProps(props=defaultSuperProps) {
  return (dispatch, getState) => {
    if (!props.userId)
      console.error('Downtime Dollars UserId is required to register mixpanel super props.');
    if (!props.loyaltyId)
      console.error('Loyalty id is required to register mixpanel super props.');

    mixpanel.register(props);
  }
}

export function startSession(loyaltyId) {
  return (dispatch, getState) => {
    appStart();
    // linkLoyaltyCard();
    setPerson(loyaltyId);
    startMixpanelTimer()(dispatch, getState);
  }
}

function appStart() {
  mixpanel.people.increment('App Start');
  mixpanel.track('App Start');
}

// function linkLoyaltyCard() {
//   mixpanel.track('Loyalty Card Linked', {
//     Input: 'Single Sign On',
//     deviceId: (
//       (window && window.navigator && window.navigator.appVersion)
//       ? window.navigator.appVersion
//       : 'ShopRite Web'
//     )
//   });
// }

function setPerson(loyaltyId) {
  mixpanel.identify(loyaltyId);
  mixpanel.people.set({
    'Application ID': 'Downtime Dollars Web',
    'Adjoy Standalone App': false,
    'Bluetooth enabled': false,
    'Browser Version': (
      (window && window.navigator && window.navigator.appVersion)
      ? window.navigator.appVersion
      : 'n/a'
    ),
    'OS': (
      (window && window.navigator && window.navigator.appVersion)
      ? window.navigator.appVersion
      : 'n/a'
    ),
    'Carrier': 'n/a'
  });

  mixpanel.people.union({
    'App version': VERSION
  });
}


/*
  Send Session Interval
  and Start New Session Timer
*/
function startMixpanelTimer() {
  return (dispatch, _) => {
    const lastSession = Cookies.get('adjoy_mixpanel_lastSession');
    const newSession  = new Date().getTime();

    // If there's a last session, send time difference to mixpanel
    if (lastSession) {
      const sessionDiff = (newSession - lastSession) / 1000; // seconds
      mixpanel.track('Session Interval', { Duration: sessionDiff });
    }

    // Start New Session Timer
    dispatch({
      type: START_TIMER,
      payload: newSession
    });
  }
}

/*
  Required Props basd on Kind:
    kind == ratable,      requires VolumeWhenVideoFinished
    kind == this_or_that, requires ImageLoadingDuration
    kind == choose,       requires ImageLoadingDuration

  Required Props for all:
    Brand:<brand name>
    Engagement:<engagement.id>
    Kind: <engagement.kind>
    Answer: <answer id>
    Duration:<duration in seconds>
*/
// const defaultEngagement = {
//   brandName: undefined,
//   engagementId: undefined,
//   kind: undefined,
//   answer: undefined,
//   duration: undefined,
//   volumeWhenVideoFinished: 1.0
// }
// export function sendEngagementAnswerToMixpanel(engagement=defaultEngagement) {
//   return (dispatch, getState) => {
//     const {
//       brandName,
//       engagementId,
//       kind,
//       answer,
//       duration,
//       volumeWhenVideoFinished
//     } = engagement;
//
//     // Verify data
//     if (brandName === undefined || brandName === null || brandName.length < 1)
//       console.error('Mixpanal - engagement answer requires a brandName.');
//     if (engagementId === undefined || engagementId === null || engagementId.length < 1)
//       console.error('Mixpanal - engagement answer requires an engagementId.');
//     if (kind === undefined || kind === null || kind.length === 0)
//       console.error('Mixpanal - engagement answer requires a kind.');
//     if (answer === undefined || answer === null || answer.length === 0)
//       console.error('Mixpanal - engagement answer requires an answer.');
//     if (duration === undefined || duration === null || duration.length === 0)
//       console.error('Mixpanal - engagement answer requires a duration.');
//     if (volumeWhenVideoFinished === undefined || volumeWhenVideoFinished === null || volumeWhenVideoFinished < 0 || volumeWhenVideoFinished > 1)
//       console.error('Mixpanal - engagement answer requires a volumeWhenVideoFinished between 0.0 and 1.0');
//
//     // Increment # of Engagements Completed
//     mixpanel.people.increment('Engagements');
//
//     // Required by all engagements
//     const props = {
//       Brand: brandName,
//       Engagement: engagementId,
//       Kind: kind,
//       Answer: answer,
//       Duration: duration,
//     }
//
//     // Add specific properties to each engagement
//     switch (kind) {
//       case 'choose':
//         mixpanel.track('Complete Engagement', {
//           ...props,
//           ImageLoadingDuration: 0,
//         });
//         break;
//
//       case 'this_or_that':
//         mixpanel.track('Complete Engagement', {
//           ...props,
//           ImageLoadingDuration1: 0,
//           ImageLoadingDuration2: 0,
//         });
//         break;
//
//       case 'ratable':
//         mixpanel.track('Complete Engagement', {
//           ...props,
//           VolumeWhenVideoFinished: 1.0,
//         });
//         break;
//
//       default:
//         break;
//     }
//   }
// }

/*
  Required properties:
    Brand:<brand name>
    Campaign:<campaign.id>
    Duration:<duration in seconds>
*/
// const defaultCompletionAnswer = {
//   brandName: undefined,
//   campaignId: undefined,
//   conclusionDuration: undefined,
//   campaignDuration: undefined,
//   userRating: undefined
// }
// export function sendCompletionAnswerToMixpanel(completionAnswer=defaultCompletionAnswer) {
//   return (dispatch, getState) => {
//     const {
//       brandName,
//       campaignId,
//       conclusionDuration,
//       campaignDuration,
//       userRating
//     } = completionAnswer;
//
//     if (brandName === undefined || brandName === null)
//       console.error('Mixpanel - completion answer requires a brandName.');
//     if (campaignId === undefined || campaignId === null || campaignId.length < 1)
//       console.error('Mixpanel - completion answer requires a campaignId.');
//     if (conclusionDuration === undefined || conclusionDuration === null)
//       console.error('Mixpanel - completion answer requires a conclusion duration.');
//     if (campaignDuration === undefined || campaignDuration === null)
//       console.error('Mixpanel - completion answer requires a campaign duration.');
//
//     // Increment # of Campaigns Completed
//     mixpanel.people.increment('Campaigns');
//
//     const completionData = {
//       Brand: brandName,
//       Campaign: campaignId
//     };
//
//     mixpanel.track('Complete Campaign', {
//       ...completionData,
//       Duration: campaignDuration
//     })
//     if (userRating) {
//       mixpanel.track('Enjoyment Response - Yes', {
//         ...completionData,
//         Duration: conclusionDuration,
//         Rate: userRating
//       });
//     } else {
//       mixpanel.track('Enjoyment Response - No', {
//         ...completionData,
//         Duration: conclusionDuration
//       });
//     }
//   }
// }

/*
  Sends Session Duration and saves new lastSession

  Send to Mixpanel:
    - session duration

  Save to Cookies:
    - current time for session interval
  NOTE: DO NOT RETURN NULL - this opens an alert() in IE and Safari
*/
// export function mixpanelOnBeforeCloseHandler() {
//   return (_, getState) => {
//     window.addEventListener('beforeunload', (e) => {
//       const totalSessionDuration = getState().mixpanel.totalSessionDuration;
//       const startTime  = getState().mixpanel.startTime;
//       const endTime    = new Date().getTime();
//       const currSessionDuration = (endTime - startTime);
//
//       var finalSessionDuration = totalSessionDuration + currSessionDuration;
//       finalSessionDuration /= 1000; // seconds
//
//       Cookies.set('adjoy_mixpanel_lastSession', endTime);
//       mixpanel.track('Session Duration', { Duration: finalSessionDuration });
//     });
//   }
// }

/*
  Pause Session Duration Timer when Window is hidden
  Start Session Duration Timer when Window is active

  NOTE: add to state.mixpanel.totalSessionDuration on page hidden
  NOTE: remember to use MILLISECONDS!
        Seconds is calculated here: mixpanelOnBeforeCloseHandler()
*/
// export function mixpanelPageVisibilitySessionDurationTimer() {
//   return (dispatch, getState) => {
//     // Start Timer
//     var pageVisible = () => {
//       dispatch({ type: START_TIMER });
//     }
//
//     // Add to total session duration
//     var pageHidden = () => {
//       const startTime = getState().mixpanel.startTime;
//       const endTime = new Date().getTime();
//       var currSessionDuration = endTime - startTime;
//
//       dispatch({
//         type: ADD_TO_TOTAL_SESSION_DURATION,
//         payload: currSessionDuration
//       });
//     }
//
//     pageVisibilityListener(pageVisible, pageHidden);
//   }
// }

/*
  Page Specific Functions
*/
// Home Page
// export function getStartedClick() {
//   return () => {
//     mixpanel.people.increment('Get Started button');
//   }
// }

// Tutorial Page
// export function firstTimeTutorial() {
//   return () => {
//     mixpanel.people.set_once('First Time Tutorial', true);
//     mixpanel.track('First Time Tutorial');
//   }
// }

// Account Page
// export function sendCouponActivationToMixpanel(couponAmt) {
//   return () => {
//     if (couponAmt % 3 !== 0)
//       console.error('Mixpanel - coupon amount must be a multiple of 3.');
//     if (couponAmt < 3 || couponAmt > 12)
//       console.error('Mixpanel - coupon amount must be between 3 and 12');
//
//     // Update mixpanel person profile and track event
//     mixpanel.people.increment(`Account screen - $${couponAmt} Activation`);
//     mixpanel.track(`Account screen - $${couponAmt} Activation`);
//   };
// }

// Increment Page View
// export function incrementPageView(pageName) {
//   return () => {
//     mixpanel.people.increment(pageName);
//   }
// }

// Finished All Campaigns Event
export function finishAllCampaignsEvent() {
  return () => {
    mixpanel.track('Completed All Campaigns');
    mixpanel.people.increment('Completed All Campaigns');
  }
}

// Share Social Media Event
// socialMediaName => facebook, twitter, etc.
export function shareSocialMediaEvent(socialMediaName=undefined) {
  return () => {

    if (!socialMediaName)
      console.error('Social media name required to send mixpanel event.');

    mixpanel.track('Social Media Shared', { socialMediaName: socialMediaName });
    mixpanel.people.increment(`${socialMediaName} shares`);
  }
}



// WEBPACK FOOTER //
// ./src/redux/mixpanel/actions.js